var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, normalizeAndEncodeString, dataLayerPush } from "../shared/utils";
var chosenEventsHandler = function (e) {
    var baseResetData = {
        non_interaction: false,
        event_errors: 0,
        total_errors: 0,
        standard_interactions: 0,
        std_pdp_view: 0,
        hi_add_to_carts: 0,
        high_intent_interactions: 0,
        hi_checkout_start: 0,
        screen_name: ""
    };
    var chosenEventData = e && e.detail
        && Object.assign({}, baseResetData, normalizeObject(e.detail));
    var eventKey = e === null || e === void 0 ? void 0 : e.type;
    if (eventKey === "chosen_product_view") {
        dataLayerPush({ ecommerce: null });
        dataLayerPush(__assign(__assign({}, chosenEventData), { event: "view_item", event_action: "view_item", event_category: "ecommerce", event_label: "chosen_sponsorship", non_interaction: true, standard_interactions: 1, std_pdp_view: 1, ecommerce: {
                items: [
                    {
                        item_brand: "chosen",
                        item_category: "sponsorship",
                        item_id: "S1000002",
                        item_variant: "monthly:" + chosenEventData["product_price"],
                        item_name: "chosen_sponsorship",
                        price: chosenEventData["product_price"],
                        quantity: chosenEventData["product_quantity"],
                    },
                ],
            } }));
    }
    if (eventKey === "chosen_add_to_cart") {
        dataLayerPush({ ecommerce: null });
        dataLayerPush(__assign(__assign({}, chosenEventData), { event: "add_to_cart", event_action: "add_to_cart", event_category: "ecommerce", event_label: "chosen_sponsorship", hi_add_to_carts: 1, high_intent_interactions: 1, ecommerce: {
                items: [
                    {
                        item_brand: "chosen",
                        item_category: "sponsorship",
                        item_id: "S1000002",
                        item_variant: "monthly:" + chosenEventData["product_price"],
                        item_name: "chosen_sponsorship",
                        price: chosenEventData["product_price"],
                        quantity: chosenEventData["product_quantity"],
                    },
                ],
            } }));
        dataLayerPush({ ecommerce: null });
        dataLayerPush(__assign(__assign({}, chosenEventData), { event: "begin_checkout", event_action: "begin_checkout", event_category: "ecommerce", event_label: "chosen_sponsorship", checkout_type: "chosen", step_number: 1, hi_add_to_carts: 0, hi_checkout_start: 1, high_intent_interactions: 1, ecommerce: {
                items: [
                    {
                        item_brand: "chosen",
                        item_category: "sponsorship",
                        item_id: "S1000002",
                        item_variant: "monthly:" + chosenEventData["product_price"],
                        item_name: "chosen_sponsorship",
                        price: chosenEventData["product_price"],
                        quantity: chosenEventData["product_quantity"],
                    },
                ],
            } }));
    }
    if (eventKey === "chosen_event_ended" ||
        eventKey === "chosen_event_not_found" ||
        eventKey === "chosen_photo_deny") {
        dataLayerPush(__assign(__assign({}, baseResetData), { event: "error_view", event_action: eventKey, event_category: "chosen_error", event_label: normalizeAndEncodeString(chosenEventData["error_message"] || ""), error_type: "chosen_error", error_message: normalizeAndEncodeString(chosenEventData["error_message"] || ""), event_errors: 1, total_errors: 1, non_interaction: true }));
    }
    if (eventKey === "virtual_page_view") {
        var vpvData = Object.assign({}, normalizeObject(__assign(__assign({}, baseResetData), { event: "page_view", page_display_type: "vpv", page_name: chosenEventData["vpv_name"], page_template: chosenEventData["vpv_template"], page_location: document.location.origin + chosenEventData["vpv"], page_path: chosenEventData["vpv"], page_title: "VPV " + chosenEventData["vpv_name"] })));
        dataLayerPush(vpvData);
    }
};
export { chosenEventsHandler };
